export default __webpack_public_path__ + "static/media/bergen_gondol2.af8a5cbc.jpg";